import React from "react";
import { useNavigate } from "react-router-dom";
import { useEffect } from "react";
import apiRequest from "../../apiCall";
import { useDispatch } from "react-redux";
import { setLoading } from "../../Redux/action";

const Shop = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  useEffect(() => {
    apiRequest("GET", "recommended-products/", null, false, false)
      .then((res) => {
        dispatch(setLoading(true));
        if (res?.data.length > 0) {
          const productName = res.data[0].heading.replaceAll(" ", "-");
          navigate("/shop/" + productName);
        }
        dispatch(setLoading(false));
      })
      .catch((error) => {
        console.error(error);
        dispatch(setLoading(false));
      });
  }, []);

  document.title = "Shop - zerozero";
  return (
    <div className="shop">
      <div>No records found.</div>
    </div>
  );
};

export default Shop;
